import { Grid } from '@mui/material';
import { FC } from 'react';
import StaffPayoutGrid from './staffPayoutGrid';
import { AddButton } from 'src/views/components/simple/AllButtons';
import { useTranslation } from 'src/hooks/useTranslationHook';
import {
  useStaffPayoutActions,
  useStaffPayoutState,
} from '../../contexts/staffPayout.context';
import AddEditStaffPayoutModal from './addEditStaffPayoutModal';
import { PermissionGate } from '../../../../../components/rbac/PermissionGate';
import { RbacDeniedRedirect } from '../../../../../components/rbac/RbacDeniedRedirect';

interface StaffPayoutProps {
  // view props goes here
}

const StaffPayout: FC<StaffPayoutProps> = () => {
  const { translateText } = useTranslation();
  const { openModal } = useStaffPayoutActions();
  const {
    staffPayoutAppState: { isModalOpen, selectedPayoutForEdit },
  } = useStaffPayoutState();

  const onAddPayoutClickHandler = () => {
    openModal();
  };

  return (
    <PermissionGate
      module="staff"
      submodule="payouts"
      permission="read"
      fallback={<RbacDeniedRedirect />}
    >
      <Grid
        container
        spacing={{ xs: 1, sm: 2 }}
        sx={{
          p: { xs: 1, sm: 2 },
        }}
        id="staffPayoutContainer"
        data-testid="staff-payout-container"
      >
        {!selectedPayoutForEdit ? (
          <Grid
            item
            xs={12}
            sx={{
              display: 'flex',
              flexDirection: { xs: 'column', sm: 'row' },
              alignItems: { xs: 'stretch', sm: 'center' },
              justifyContent: { xs: 'stretch', sm: 'flex-end' },
              gap: { xs: 1, sm: 2 },
              mb: { xs: 1, sm: 0 },
            }}
            data-testid="staff-payout-header-container"
          >
            <PermissionGate
              module="staff"
              submodule="payouts"
              permission="write"
            >
              <AddButton
                label={translateText('staff.payouts.addPayout')}
                onClickHandler={onAddPayoutClickHandler}
                data-testid="staff-payout-add-button"
                sx={{
                  width: { xs: '100%', sm: 'auto' },
                }}
              />
            </PermissionGate>
          </Grid>
        ) : null}
        <Grid item xs={12}>
          <StaffPayoutGrid />
        </Grid>
        {isModalOpen && <AddEditStaffPayoutModal />}
      </Grid>
    </PermissionGate>
  );
};

export default StaffPayout;
